import { render, staticRenderFns } from "./trafficCar.vue?vue&type=template&id=e68ab264&scoped=true"
import script from "./trafficCar.vue?vue&type=script&lang=js"
export * from "./trafficCar.vue?vue&type=script&lang=js"
import style0 from "./trafficCar.vue?vue&type=style&index=0&id=e68ab264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68ab264",
  null
  
)

export default component.exports